import * as React from 'react'

const SvgAdminDashboardIcon = ({ stroke }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 13.4004V15.4004M10 9.40039V15.4004M14 5.40039V15.4004M5.8 19.4004H14.2C15.8802 19.4004 16.7202 19.4004 17.362 19.0734C17.9265 18.7858 18.3854 18.3268 18.673 17.7624C19 17.1206 19 16.2805 19 14.6004V6.20039C19 4.52023 19 3.68015 18.673 3.03842C18.3854 2.47393 17.9265 2.01499 17.362 1.72737C16.7202 1.40039 15.8802 1.40039 14.2 1.40039H5.8C4.11984 1.40039 3.27976 1.40039 2.63803 1.72737C2.07354 2.01499 1.6146 2.47393 1.32698 3.03842C1 3.68015 1 4.52023 1 6.20039V14.6004C1 16.2805 1 17.1206 1.32698 17.7624C1.6146 18.3268 2.07354 18.7858 2.63803 19.0734C3.27976 19.4004 4.11984 19.4004 5.8 19.4004Z"
      stroke={stroke ? stroke : '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgAdminDashboardIcon
